import React, { useState } from "react";
import "./MyProfileSection2.css";
import images from "../../../Utils/importImages";
import { useDispatch, useSelector } from "react-redux";
import GeneralDetails from "./GeneralDetails";
import PassportDetails from "./PassportDetails";
import GeneralDetailsEdit from "./GeneralDetailsEdit";
import PassportDetailsEdit from "./PassportDetailsEdit";
import { setUserLoggedInData } from "../../../Redux/Slices/User_Slices/User-SLICE";
import toast from "react-hot-toast";
import { getLocalStorageJSON } from "../../../Utils/localStorageFunc";
import { UpdateUserGeneralData } from "../../../Redux/Apis/User-Apis";

function MyProfileSection2() {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  let [generalDetail, setGeneralDetail] = useState(
    userLoggedInData?.user_data?.[0]
  );

  console.log("generalDetail is : ", generalDetail);

  let [EditGeneralProfile, setEditGeneralProfile] = useState(false);
  let [EditPassportProfile, setEditPassportProfile] = useState(false);

  let onCancelGeneralDetail = () => {
    setEditGeneralProfile(false);
  };
  let onCancelPassportDetail = () => {
    setEditPassportProfile(false);
  };

  let onSaveProfileDetail = async (data, mode) => {
    console.log("updated data is : ", data);

    try {
      let dd = {
        ...generalDetail,
        ...data,
      };

      console.log("dd is : " , dd);
      
      let token = getLocalStorageJSON(isUserLogin ? "UL" : "AL");
      
      let resp = await UpdateUserGeneralData(dd , userLoggedInData.id , token);
      
      if(resp.error == false){

        setGeneralDetail(dd);
  
        let dm = {
          ...userLoggedInData,
          user_data: [{ ...dd }],
        };
  
        console.log("dm is : " , dm);
        
  
        dispatch(setUserLoggedInData(dm));
  
        console.log("mode is : ", mode);
  
        if (mode == "detail") {
          toast.success("Profile Data Updated Sucessfully", {
            style: {
              fontFamily: `var(--font-family-proxima_nova-semibold)`,
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
            },
          });
          setEditGeneralProfile(false);
        } else if (mode == "passport") {
          toast.success("Passport Data Updated Sucessfully", {
            style: {
              fontFamily: `var(--font-family-proxima_nova-semibold)`,
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
            },
          });
          setEditPassportProfile(false);
        }

      }
    } catch (error) {}
  };

  return (
    <div className="userdb-content-right">
      {EditGeneralProfile ? (
        <GeneralDetailsEdit
        generalDetails={generalDetail}
          onClickCancel={onCancelGeneralDetail}
          onClickSave={onSaveProfileDetail}
        />
      ) : (
        <GeneralDetails
          generalDetail={generalDetail}
          setEditGeneralProfile={setEditGeneralProfile}
        />
      )}
      {EditPassportProfile ? (
        <PassportDetailsEdit
        generalDetails={generalDetail}
          onClickCancel={onCancelPassportDetail}
          onClickSave={onSaveProfileDetail}
        />
      ) : (
        <PassportDetails
          generalDetail={generalDetail}
          setEditPassportProfile={setEditPassportProfile}
        />
      )}
    </div>
  );
}

export default MyProfileSection2;
